import { IRootState } from './index';
import { LoginState } from './login.types';

export const selectLogin = ({ login }: IRootState): LoginState => login;

export const selectIsLogin = ({ login }: IRootState): boolean => login.isLogged;
